var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.WidgetBaseComponent, {
    staticClass: "expedient-profitability-widget",
    attrs: { loadedData: _setup.renderWidget && !_setup.showSpinner },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "title-and-tooltip" },
              [
                _c("h2", [_vm._v(_vm._s(_setup.title))]),
                _setup.userHasPermissionToInvoiceAtLeastOneInvoiceType
                  ? _c(_setup.LexonTooltipComponent, {
                      staticClass: "tooltip",
                      attrs: {
                        icon: _setup.icons.tooltip,
                        message: _setup.texts.tooltip,
                        position: "top",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _setup.userHasPermissionToInvoiceAtLeastOneInvoiceType
              ? _c("button", {
                  class: [
                    _setup.icons.openWindow,
                    "open-window-button",
                    "lf-icon__md",
                  ],
                  on: { click: _setup.launchDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "resumes-container" },
              _vm._l(_setup.counters, function (counter, index) {
                return _c(_setup.LfWhiteCounterComponent, {
                  key: `counter-${index}`,
                  staticClass: "counter-item",
                  attrs: { info: counter },
                })
              }),
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }